import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {CreateRequestComponent} from "common-domain";
import {AuthGuard, ComponentDeactivateGuardService} from "common-domain";


const routes: Routes = [
  {
    path: 'domain/create-request/:name/direct-edit',
    component: CreateRequestComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ComponentDeactivateGuardService],
    data: {
      requestType: 'UPDATE'
    }
  },{
    path: 'domain/create-request/:name',
    canActivate: [AuthGuard],
    component: CreateRequestComponent,
    canDeactivate: [ComponentDeactivateGuardService],
    data: {
      requestType: 'UPDATE'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DomainRoutingModule {
}
